module.exports = __webpack_public_path__ + "media/img/patterns/pattern-2-822de49d3c48b06b773d85562b8baff6.png";